
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48"> 
          <a-col :md="6" :sm="24">
            <a-form-item label="年度">
              <a-select v-model="queryParam.year" allowClear  placeholder="清选择年度" >
              <a-select-option  value="2021" :key="year">2021-2022</a-select-option>
            </a-select>
            </a-form-item>
          </a-col> 
          <a-col :md="6" :sm="24">
            <a-form-item label="月份">
              <a-select v-model="queryParam.month" allowClear  placeholder="清选择月份" >
              <a-select-option  value="1" :key="year">1</a-select-option>
              <a-select-option  value="2" :key="year">2</a-select-option>
              <a-select-option  value="3" :key="year">3</a-select-option>
              <a-select-option  value="4" :key="year">4</a-select-option>
              <a-select-option  value="5" :key="year">5</a-select-option>
              <a-select-option  value="6" :key="year">6</a-select-option>
              <a-select-option  value="7" :key="year">7</a-select-option>
              <a-select-option  value="8" :key="year">8</a-select-option>
              <a-select-option  value="9" :key="year">9</a-select-option>
              <a-select-option  value="10" :key="year">10</a-select-option>
              <a-select-option  value="11" :key="year">11</a-select-option>
              <a-select-option  value="12" :key="year">12</a-select-option>
            </a-select>
            </a-form-item>
          </a-col> 
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear  placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>
 
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select v-model="queryParam.status" placeholder="请选择"
                        allowClear >
                <a-select-option value="1">等待审核</a-select-option>
                <a-select-option value="2">审核成功</a-select-option>
                <a-select-option value="3">审核失败</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="授权编号">
                <a-input v-model="queryParam.kaojiregist_code" placeholder="搜索授权编号"/>
              </a-form-item>
            </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="单位名称">
              <a-input v-model="queryParam.danwei" placeholder="搜索单位名称"/>
            </a-form-item>
          </a-col>


          <a-col :md="6" :sm="24">
            <a-form-item label="考试时间">
              <a-range-picker
                      v-model="time_range_moment"
                      style="width: 100%"
                      format="YYYY-MM-DD HH:mm:ss"
                      :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
              />
            </a-form-item>
          </a-col>

           </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>

              <a-button icon="setting" style="margin-left: 8px" @click="onCompute()">重新计算奖励</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator" v-if="false" >

      <a-button @click="download" style="margin-left: 8px">
        订单明细下载 <a-icon type="download" />
      </a-button>

      <a-button @click="cashHandle('business')"  v-if="selectedRowKeys.length > 0" style="margin-left: 8px">
        商家结算 <a-icon type="money-collect" />
      </a-button>

      <a-button @click="cashHandle('seller')"  v-if="selectedRowKeys.length > 0" style="margin-left: 8px">
        分销员结算 <a-icon type="money-collect" />
      </a-button>

      <a-button @click="cashHandle('team')"  v-if="selectedRowKeys.length > 0" style="margin-left: 8px">
        团长结算 <a-icon type="money-collect" />
      </a-button>

      <a-button @click="cashHandle('dealtown')"  v-if="selectedRowKeys.length > 0" style="margin-left: 8px">
        平台结算 <a-icon type="money-collect" />
      </a-button>
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="danwei" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{record.name}} ({{record.year}}年{{record.month}}月)
            <br/>
            创建时间 {{record.create_time|timeFormat}}
            <br/>
            奖励金额  {{record.rewards_price}}元 = {{record.rewards_price_exp}}
          </div>
      </span>
      <span slot="jindu" slot-scope="text,record"> 
        <a-tag v-if="record.status==1" color="red">等待审核</a-tag>
        <a-tag v-else-if="record.status==2" color="green">审核成功</a-tag>
        <a-tag v-else-if="record.status==3" color="purple">审核失败</a-tag>
        <a-tag v-else>未提交</a-tag>
        <br/>
        <a v-if="record.resultszip && record.resultszip2">成绩已上传</a>
      </span>
      <span slot="action" slot-scope="text,record">
        <template >
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" /> 
          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="deleteHandle(record)"  okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>



    <a-modal
        :maskClosable="false"
            title="操作"
            :width="1200"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
  
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="电子发票"
                  hasFeedback
              >
                <pic-uploader
                    :numberLimit="1"
                    :file-list="formData.fapiao"
                />
              </a-form-item>

              </a-col>

              <a-col :md="12" :sm="24">
  
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="管理员备注"
                  hasFeedback
              >
              <a-textarea autosize v-decorator="[
              'admin_note',
              {rules: []}
            ]"
                            placeholder="管理员备注"/>
              </a-form-item>

              </a-col>


            </a-row>

          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
          <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="审核状态"
                  hasFeedback
          >
            <a-radio-group v-model="formData.status" buttonStyle="solid">
              <a-radio-button :value="0">未提交</a-radio-button>
              <a-radio-button :value="1">待审核</a-radio-button>
              <a-radio-button :value="2">审核通过</a-radio-button>
              <a-radio-button :value="3">审核失败</a-radio-button>
            </a-radio-group>
          </a-form-item>
              </a-col>
            </a-row>



        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>



    <a-modal
        :maskClosable="false"
            title="人员名单"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="userVisible"
            @ok="userVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-table :columns="userColumns" :dataSource="kaojiUserList" :pagination="userPagination"
                   @change="handleUserTableChange"
                   rowKey="id" :scroll="{ y: 300 }" bordered>
            <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" class='custom-filter-dropdown'>
              <a-input
                      v-model="userQuery.keywords"
                      placeholder="搜索姓名"
                      style="width: 188px; margin-bottom: 8px; display: block;"
              />
              <a-button
                      type='primary'
                      @click="userSearch(selectedKeys, confirm)"
                      icon="search"
                      size="small"
                      style="width: 90px; margin-right: 8px"
              >搜索</a-button>
              <a-button
                      @click="userSearchReset(selectedKeys, confirm)"
                      size="small"
                      style="width: 90px"
              >重置</a-button>
            </div>
            <span slot="name" slot-scope="text,record">
              {{record.name}} <br/>
              {{record.code}}
            </span>

            <span slot="action" slot-scope="text,record">
            <template >
              <a @click="handleMemberEdit(record)">编辑</a>
              <a-divider type="vertical" />
              <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="deleteMemberHandle(record)"  okText="确定" cancelText="取消">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
          </span>
          </a-table>
        </a-form>
      </a-spin>
    </a-modal>


    <a-modal
        :maskClosable="false"
            title="人员操作"
            :width="1000"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="userFormVisible"
            @ok="handleUserOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form2" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="姓名"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'name',
              {rules: [{ required: true, message: '请输入姓名' }]}
            ]"
                          placeholder="请输入姓名"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="身份证"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'num',
              {rules: [{ required: true, message: '请输入身份证' }]}
            ]"
                          placeholder="请输入身份证"/>
              </a-form-item>
            </a-col>


          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="手机"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'phone',
              {rules: []}
            ]"
                          placeholder="请输入手机"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="性别"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'sex',
              {rules: []}
            ]"
                          placeholder="请输入性别"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="等级"
                      hasFeedback
              >
                <a-select v-model="userFormData.grade" placeholder="请选择"
                          allowClear >
                  <a-select-option value="初级">初级</a-select-option>
                  <a-select-option value="中级">中级</a-select-option>
                  <a-select-option value="高级">高级</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="注册日期"
                      hasFeedback
              >

                <a-date-picker
                        v-model="userFormData.regist_date_moment"
                        format="YYYY-MM-DD"
                        placeholder="注册日期"/>

              </a-form-item>
            </a-col>


          </a-row>


        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="userFormVisible=false">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleUserOk">保存</a-button>
      </template>
    </a-modal>


  </a-card>
  </template>

  <script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import PicUploader from '@/components/PicUploader/'
  import FileUploader from '@/components/FileUploader/'
  import KaoguanPicker from '@/components/KaoguanPicker/'
  import JianduPicker from '@/components/JianduPicker/'
  import areaOptions from '@/utils/area'
  import moment from 'moment'
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');

  import { getRewardsList ,rewardsDetail,rewardsEdit ,rewardsDelete,rewardsTuijianCompute } from '@/api/qcxjrewards'
  export default {
    name: 'KaojiApplyList',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      STable,
      EditableCell,
      KaoguanPicker,
      JianduPicker,
    },
    data () {
      return {
        areaOptions,
        userFormVisible: false,
        kaoguanPickerShow: false,
        jianduPickerShow: false,
        userVisible: false,
        visible: false,
        saveLoading:false,
        formData:{
          id:0,
          danwei:'',
          datetitle_moment:null,
          datetitle:'',
          resultszip:[],
          kaoguan:[],
          jiandu:[],
          namekeys:[],
          areas:[],
        },
        time_range_moment:[],
        time_range:[],
        labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        form2: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          to_type:'tuijian_user',
          keywords:'',
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '单位信息',
            dataIndex: 'danwei',
            scopedSlots: { customRender: 'danwei' },
          },
          {
            title: '状态',
            dataIndex: 'jindu',
            scopedSlots: { customRender: 'jindu' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 200,
            scopedSlots: { customRender: 'action' },
          }
        ],


        //领取人员表头
        userColumns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '100px'
          },
          {
            title: '姓名',
            dataIndex: 'name',
            width:'150px',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'name',
            }
          },
          {
            title: '身份证',
            dataIndex: 'num'
          },
          {
            title: '等级',
            width:'100px',
            dataIndex: 'grade',
          },
          {
            title: '注册时间',
            width:'150px',
            dataIndex: 'regist_date',
            customRender: (text) =>  {
              return moment(text*1000).format('YYYY-MM-DD HH:mm:ss');
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            width:'200px',
            scopedSlots: {
              customRender: 'action',
            }
          },
        ],
        userPagination:{
        },
        userQuery:{
          manageid:0,
          status:0,
          page:1,
          keywords:undefined
        },
        userFormData:{
          id:0,
          regist_date_moment:null,
          regist_date:0,
        },
        kaojiUserList:[],


        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          let that= this;

          if (this.time_range_moment[0] && this.time_range_moment[1]) {
            this.queryParam.time_range = [
              this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
              this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
            ]
          } else {
            this.queryParam.time_range = []
          }

          this.queryParam = Object.assign(this.queryParam,parameter);
          return getRewardsList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
        },

        selectedRowKeys: [],
        selectedRows: [],
        cashFormData:{
          ids:[],
          to_type:'',
          price:0,
          note:'',
          count:0,
        }
      }
    },
    computed:{
    },
    created(){
    },

    mounted(){
      let that = this;
    },
    methods: {
      moment,
      handleCancel(){
        this.visible = false
      },
      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
      handleEdit(record){
        let self = this
        this.visible = true
        rewardsDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
            self.form.setFieldsValue({ ...res.data })
            self.formData.id = record.id;
            console.log('handleEdit')
            self.formData = { ...res.data };
          },200)
        })
        // console.log(this.mdl)
      },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },
      deleteHandle(record){
        let self = this
        rewardsDelete({ id: record.id }).then(res => {
          self.$message.success('删除成功')
          self.$refs.table.refresh(false)
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },

      deleteMemberHandle(record){
        let self = this
        memberDelete({ id: record.id }).then(res => {
          self.$message.success('删除成功')
          self.fetchUserList();
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },

      // 增改 处理
      handleOk(e) {
        let self = this;
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.saveLoading = true;
            rewardsEdit({
              id:self.formData.id,
              fapiao:self.formData.fapiao,
              status:self.formData.status,
              admin_note:values.admin_note,
            }).then(res => {
              self.$message.success('修改成功')
              self.$refs.table.refresh(false)
              self.visible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }
        })
      },
      onCompute(){
        let that = this;
        if(!this.queryParam.year){
          that.$message.error('请先选择年份');
            return ;
        }
        rewardsTuijianCompute(this.queryParam).then(res => {
          that.$message.success('操作成功')
          that.$refs.table.refresh(false) 
          that.saveLoading = false;
        }).catch(err =>{
          that.$message.error(err.data.msg);
          that.saveLoading = false;
        }) 


      },

      handleUserManage(record) {
        let self = this
        self.userQuery.manageid = record.id;
        self.userQuery.keywords = undefined;
        self.userQuery.status = undefined;
        self.userPagination.page = 1;
        self.fetchUserList();
        this.userVisible = true
      },


      fetchUserList(){
        let self = this
        getApplyMemberList(Object.assign(self.userQuery,self.userPagination)).then(res => {
          self.kaojiUserList = res.data.list
          self.userPagination.total = res.data.total
        })
      },

      userSearch(selectedKeys,confirm){
        let self = this
        confirm();
        self.fetchUserList();
      },
      userSearchReset(selectedKeys,confirm){
        let self = this;
        confirm();
        self.userQuery.keywords = undefined;
        self.fetchUserList();
      },
      handleUserTableChange(pagination, filters, sorter) {
        console.log('filters',filters);
        let that = this;
        if(filters.grade){
          that.userQuery.grade = filters.grade[0];
        }else{
          that.userQuery.grade = '';
        }
        const pager = { ...this.pagination };
        pager.current = pagination.current;
        that.pagination = pager;
        that.userQuery.page = pagination.current;
        that.fetchUserList();
      },


      handleMemberEdit(record){
        let self = this
        this.userFormVisible = true
        memberDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
            res.data.regist_date_moment = moment(res.data.regist_date*1000);
            self.form2.setFieldsValue({ ...res.data })
            self.userFormData.id = record.id;
            console.log('handleEdit')
            self.userFormData = { ...res.data };
          },200)
        })
        // console.log(this.mdl)
      },

      handleUserOk(e){
        let self = this;
        e.preventDefault()
        this.form2.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            self.saveLoading = true;

            memberEdit({
              id:self.userFormData.id,
              name:values.name,
              num:values.num,
              sex:values.sex,
              phone:values.phone,
              grade:self.userFormData.grade,
              regist_date:self.userFormData.regist_date_moment.format('YYYY-MM-DD')
            }).then(res => {
              self.$message.success('修改成功')

              self.fetchUserList();
              self.userFormVisible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })

          }
        })
      },
      download(){
        getDownloadUrl(this.queryParam).then(res =>{
          console.log(res);
          window.open(res.data);
        })
      },
    onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },

    },
    filters:{
    },
    watch: {
    }
  }
</script>


<style scoped>
  .custom-filter-dropdown {
    padding: 8px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .15);
  }

  .highlight {
    background-color: rgb(255, 192, 105);
    padding: 0px;
  }
</style>
